import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CuentaCorrienteDolaresFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CTA CTE DOLARES' htmlFor='input-cuentaCorrienteDolares' md={3} />
      <Col md={9}>
        <Field name='cuentaCorrienteDolares'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-cuentaCorrienteDolares'
              placeholder='Ingresar cuenta corriente ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaCorrienteDolaresFormGroup)
